"use client";

import React from "react";
import type { EmptyStateConfig } from "@/hooks/usePanelState";

interface EmptyBlockProps {
  config: EmptyStateConfig;
  className?: string;
}

/**
 * Designed empty state — a centered glyph, one-line message, and an optional
 * action link. Replaces ad-hoc "no rows" text across blotters and lists.
 */
export function EmptyBlock({ config, className }: EmptyBlockProps) {
  const { glyph, message, action } = config;
  return (
    <div
      className={`flex flex-1 flex-col items-center justify-center gap-1.5 px-3 py-6 text-center ${className ?? ""}`}
    >
      <div
        aria-hidden
        className="text-2xl leading-none text-muted-foreground/70"
      >
        {glyph}
      </div>
      <p className="text-[11px] font-mono text-muted-foreground">{message}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="text-[11px] font-mono text-blue-400 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 rounded"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}

export default EmptyBlock;
